module.exports = __webpack_public_path__ + "static/img/antools_app_icon36459.8c4e464.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antools_app_icon36459.svg
// module id = sqyI
// module chunks = 1